export const INDUSTRY_SEO_PAGES = {
  cleaning: {
    id: 'cleaning',
    svPath: '/hemsida-stadfirma',
    arPath: '/ar/hemsida-stadfirma',
    labelSv: 'Städfirma',
    labelAr: 'شركة تنظيف',
    shortSv: 'Tjänster, RUT, områden och offertförfrågan på en tydlig sida.',
    shortAr: 'الخدمات وRUT ومناطق العمل وطلب عرض السعر في صفحة واضحة.',
    sv: {
      metaTitle: 'Hemsida för städfirma som gör det lätt att be om offert | StartaWebb',
      metaDescription: 'En tydlig hemsida för städföretag med hemstädning, flyttstädning, kontorsstädning, RUT, områden och offertformulär. Riktpris cirka 4 900 kr.',
      keywords: 'hemsida städfirma, webbdesign städföretag, hemsida flyttstädning, hemsida hemstädning, offertformulär städfirma',
      eyebrow: 'Hemsida för städföretag i Sverige',
      title: 'Visa tjänster, RUT och arbetsområden innan kunden behöver fråga.',
      intro: 'En städfirma behöver mer än ett telefonnummer. Kunden ska snabbt förstå vad ni städar, var ni arbetar, hur priset hanteras och hur en offertförfrågan skickas.',
      fitTitle: 'Sidan passar när ni vill',
      fit: [
        ['Få tydligare förfrågningar', 'Samla bostadstyp, storlek, datum och önskad tjänst i formuläret.'],
        ['Bygga förtroende', 'Visa RUT, försäkring, arbetssätt, bilder och omdömen utan överdrivna löften.'],
        ['Synas lokalt', 'Beskriv riktiga tjänster och områden i stället för tunna, upprepade stadssidor.'],
      ],
      includedTitle: 'Det viktigaste på en städfirmas hemsida',
      included: [
        'Hemstädning, flyttstädning, kontorsstädning och övriga verkliga tjänster',
        'Arbetsområden och orter där företaget faktiskt tar uppdrag',
        'RUT-information och tydlig förklaring av hur pris eller offert fungerar',
        'Klickbart telefonnummer, kontaktformulär och eventuell WhatsApp-länk',
        'Förtroendesignaler som organisationsnummer, försäkring och villkor när de finns',
        'Mobilanpassning, grundläggande SEO och hjälp med publicering och domän',
      ],
      detailTitle: 'Bygg sidan runt kundens beslut',
      details: [
        ['Tjänsten först', 'En besökare som söker flyttstädning ska direkt se vad som ingår, vilka uppgifter ni behöver och hur nästa steg går till.'],
        ['Priset utan missförstånd', 'Använd fast pris, frånpris, timpris eller offert beroende på hur företaget faktiskt arbetar. Sidan ska inte lova ett pris som ändå ändras senare.'],
        ['RUT och ansvar', 'Förklara RUT enkelt men låt företaget bekräfta att uppgifterna stämmer med den egna faktureringen och aktuella regler.'],
      ],
      processTitle: 'Från information till publicerad städsida',
      process: [
        ['01', 'Samla material', 'Tjänster, orter, kontaktvägar, logotyp, bilder och prisupplägg.'],
        ['02', 'Skriv strukturen', 'Tydliga svenska texter byggs från företagets riktiga erbjudande.'],
        ['03', 'Bygg och testa', 'Mobil, formulär, telefonlänkar och viktiga sidor kontrolleras.'],
        ['04', 'Godkänn och publicera', 'Företaget granskar uppgifterna innan domänen kopplas och sidan publiceras.'],
      ],
      faqTitle: 'Vanliga frågor om hemsida för städfirma',
      faqs: [
        ['Behöver vi visa exakta priser?', 'Nej. Om priset varierar kan sidan använda frånpris eller ett offertformulär som samlar rätt uppgifter.'],
        ['Kan sidan hjälpa med lokala Google-sökningar?', 'Den kan byggas med tydliga tjänster, områden, metadata och teknisk grund. Ingen seriös leverantör kan garantera en viss placering.'],
        ['Kan vi lägga till bokning senare?', 'Ja. Många börjar med offertförfrågan och lägger till bokningsflöde när tjänster, tider och priser är tillräckligt standardiserade.'],
        ['Vad kostar en enkel städfirmasida?', 'Riktpriset är cirka 4 900 kr. Slutpris och eventuell moms anges i den skriftliga offerten efter att omfattningen är tydlig.'],
      ],
      ctaTitle: 'Skicka företagets tjänster och arbetsområden',
      ctaText: 'Du får ett avgränsat förslag. Inget arbete startar innan omfattning och pris har godkänts skriftligt.',
    },
    ar: {
      metaTitle: 'موقع لشركة تنظيف في السويد مع طلب عرض سعر واضح | StartaWebb',
      metaDescription: 'موقع سويدي لشركة التنظيف يعرض hemstädning وflyttstädning وRUT ومناطق العمل ونموذج طلب السعر، مع شرح ودعم بالعربية.',
      keywords: 'موقع شركة تنظيف السويد, hemsida städfirma, تصميم موقع شركة تنظيف, موقع flyttstädning, مصمم مواقع عربي السويد',
      eyebrow: 'موقع لشركة تنظيف في السويد',
      title: 'اجعل العميل يفهم الخدمات وRUT ومنطقة العمل قبل أن يضطر للسؤال.',
      intro: 'نتواصل معك بالعربية، ثم نبني موقعًا باللغة السويدية يوضح ما تنظفه الشركة، أين تعمل، كيف يُحسب السعر، وكيف يرسل العميل طلبًا يحتوي على المعلومات اللازمة.',
      fitTitle: 'الموقع مناسب عندما تريد الشركة',
      fit: [
        ['طلبات أوضح', 'جمع نوع السكن والمساحة والتاريخ والخدمة المطلوبة داخل النموذج.'],
        ['ثقة أكبر', 'عرض RUT والتأمين وطريقة العمل والصور والتقييمات الحقيقية.'],
        ['ظهور محلي منطقي', 'كتابة خدمات ومناطق حقيقية بدل صفحات مدن مكررة بلا قيمة.'],
      ],
      includedTitle: 'أهم ما يحتاجه موقع شركة التنظيف',
      included: [
        'Hemstädning وflyttstädning وkontorsstädning والخدمات التي تقدمها الشركة فعلًا',
        'المدن ومناطق العمل الحقيقية',
        'شرح RUT وطريقة السعر أو طلب عرض السعر',
        'رقم قابل للضغط ونموذج تواصل وواتساب عند الحاجة',
        'رقم المنظمة والتأمين والشروط عندما تكون متوفرة',
        'توافق مع الهاتف وSEO أساسي وربط النطاق والنشر',
      ],
      detailTitle: 'ابنِ الصفحة حول قرار العميل',
      details: [
        ['الخدمة أولًا', 'من يبحث عن flyttstädning يجب أن يرى مباشرة ما الذي يشمله العمل وما المعلومات المطلوبة للبدء.'],
        ['سعر بلا التباس', 'يمكن استعمال سعر ثابت أو سعر ابتدائي أو بالساعة أو عرض سعر حسب طريقة عمل الشركة الحقيقية.'],
        ['RUT والمسؤولية', 'نشرح RUT ببساطة، لكن الشركة تؤكد صحة المعلومات وطريقة الفوترة قبل النشر.'],
      ],
      processTitle: 'من معلومات الشركة إلى موقع منشور',
      process: [
        ['01', 'نجمع المواد', 'الخدمات والمدن وطرق التواصل والشعار والصور وطريقة السعر.'],
        ['02', 'نكتب الهيكل', 'نصوص سويدية واضحة مبنية على العرض الحقيقي للشركة.'],
        ['03', 'نبني ونختبر', 'الهاتف والنموذج والروابط والصفحات المهمة.'],
        ['04', 'تراجع وتنشر', 'تؤكد الشركة البيانات قبل ربط النطاق والنشر.'],
      ],
      faqTitle: 'أسئلة شائعة عن موقع شركة التنظيف',
      faqs: [
        ['هل يجب وضع أسعار دقيقة؟', 'لا. عندما يختلف السعر يمكن استعمال سعر ابتدائي أو نموذج يجمع المعلومات ثم ترسل الشركة عرضًا مناسبًا.'],
        ['هل يضمن الموقع الظهور الأول في Google؟', 'لا. نبني أساسًا تقنيًا ومحتوى واضحًا، لكن لا يمكن ضمان ترتيب محدد.'],
        ['هل يمكن إضافة الحجز لاحقًا؟', 'نعم. كثير من الشركات تبدأ بطلب عرض السعر ثم تضيف الحجز عندما تصبح الخدمات والأسعار والأوقات موحدة.'],
        ['كم يكلف الموقع البسيط؟', 'السعر الإرشادي نحو 4,900 كرون. السعر النهائي والضريبة إن وجدت يذكران في عرض مكتوب بعد تحديد العمل.'],
      ],
      ctaTitle: 'أرسل خدمات الشركة ومناطق العمل',
      ctaText: 'تحصل على اقتراح محدد، ولا يبدأ العمل قبل الموافقة كتابة على المحتوى والسعر.',
    },
  },

  moving: {
    id: 'moving',
    svPath: '/hemsida-flyttfirma',
    arPath: '/ar/hemsida-flyttfirma',
    labelSv: 'Flyttfirma',
    labelAr: 'شركة نقل',
    shortSv: 'Tjänster, områden, försäkring och ett formulär som samlar flyttens detaljer.',
    shortAr: 'الخدمات والمناطق والتأمين ونموذج يجمع تفاصيل النقل.',
    sv: {
      metaTitle: 'Hemsida för flyttfirma med bättre offertförfrågningar | StartaWebb',
      metaDescription: 'Hemsida för flyttföretag med privatflytt, företagsflytt, bärhjälp, områden, försäkring och formulär för flyttens detaljer. Riktpris cirka 4 900 kr.',
      keywords: 'hemsida flyttfirma, webbdesign flyttföretag, flytthjälp hemsida, offertformulär flyttfirma, hemsida bärhjälp',
      eyebrow: 'Hemsida för flyttföretag i Sverige',
      title: 'Samla flyttens viktigaste detaljer innan ni räknar på jobbet.',
      intro: 'Ett bra flyttformulär frågar inte bara efter namn och telefon. Det hjälper kunden att ange adresser, datum, våningar, hiss, omfattning och tilläggstjänster.',
      fitTitle: 'Sidan passar när ni vill',
      fit: [
        ['Minska ofullständiga förfrågningar', 'Fråga efter det som behövs för att bedöma tid, bil, personal och pris.'],
        ['Visa trygghet', 'Förklara försäkring, arbetssätt, kontaktvägar och vad som ingår.'],
        ['Sälja rätt tjänst', 'Skilj på privatflytt, företagsflytt, bärhjälp, packning och montering.'],
      ],
      includedTitle: 'Det viktigaste på en flyttfirmas hemsida',
      included: [
        'Privatflytt, företagsflytt, bärhjälp, packning, montering och andra verkliga tjänster',
        'Arbetsområden, avstånd och hur resor eller framkörning hanteras',
        'Offertformulär med adresser, datum, våningar, hiss och omfattning',
        'Försäkring, organisationsuppgifter och tydliga kontaktvägar',
        'Prisupplägg utan vilseledande lockpris eller dolda villkor',
        'Mobilanpassning, grundläggande SEO, domänkoppling och publicering',
      ],
      detailTitle: 'Låt formuläret göra en del av förarbetet',
      details: [
        ['Rätt frågor sparar tid', 'När kunden lämnar adresser, våningar, hiss och bilder vid behov kan företaget snabbare avgöra nästa steg.'],
        ['Tydligt prisupplägg', 'Visa timpris, minsta debitering, bil- eller avståndskostnad och vad som kräver separat bedömning när det passar verksamheten.'],
        ['Trygghet före kontakt', 'Ansvarsförsäkring, organisationsnummer och ett tydligt arbetssätt är ofta viktigare än stora reklamlöften.'],
      ],
      processTitle: 'Så byggs en flyttsida som går att använda',
      process: [
        ['01', 'Avgränsa tjänster', 'Bestäm vilka typer av flytt, bärhjälp och tillägg som ska visas.'],
        ['02', 'Planera offertfrågorna', 'Samla bara information som företaget faktiskt behöver för bedömningen.'],
        ['03', 'Bygg och testa', 'Kontrollera formulär, mobil, telefon, WhatsApp och viktiga länkar.'],
        ['04', 'Godkänn och publicera', 'Företaget granskar priser, villkor och försäkringsinformation före lansering.'],
      ],
      faqTitle: 'Vanliga frågor om hemsida för flyttfirma',
      faqs: [
        ['Ska kunden kunna boka direkt?', 'Inte alltid. För många flyttar är offertförfrågan säkrare eftersom omfattning, adresser och tillgänglighet påverkar priset.'],
        ['Kan kunden skicka bilder?', 'Ja, men uppladdning och lagring är en extra funktion som avgränsas separat från ett enkelt kontaktformulär.'],
        ['Kan vi skapa sidor för flera städer?', 'Ja när företaget verkligen arbetar där och kan ge unik, relevant information. Kopierade stadssidor utan värde bör undvikas.'],
        ['Vad kostar en enkel flyttfirmasida?', 'Riktpriset är cirka 4 900 kr. Slutpris och eventuell moms anges efter att funktioner och omfattning har bestämts.'],
      ],
      ctaTitle: 'Beskriv flyttjänsterna och hur ni räknar pris',
      ctaText: 'Skicka gärna en befintlig länk, Facebook-sida eller enkel lista. Ett skriftligt förslag lämnas före start.',
    },
    ar: {
      metaTitle: 'موقع لشركة نقل في السويد مع نموذج عرض سعر أفضل | StartaWebb',
      metaDescription: 'موقع سويدي لشركة النقل يعرض privatflytt وbärhjälp والتأمين ومناطق العمل ويجمع العناوين والطوابق والتاريخ، مع دعم بالعربية.',
      keywords: 'موقع شركة نقل السويد, hemsida flyttfirma, موقع flytthjälp, تصميم موقع شركة نقل, مصمم مواقع عربي السويد',
      eyebrow: 'موقع لشركة نقل في السويد',
      title: 'اجمع أهم تفاصيل النقل قبل أن تبدأ الشركة في حساب العمل.',
      intro: 'النموذج الجيد لا يطلب الاسم والهاتف فقط؛ بل يساعد العميل على إرسال العناوين والتاريخ والطوابق والمصعد والحجم والخدمات الإضافية.',
      fitTitle: 'الموقع مناسب عندما تريد الشركة',
      fit: [
        ['طلبات غير ناقصة', 'جمع المعلومات التي تساعد على تقدير الوقت والسيارة والعمال والسعر.'],
        ['ثقة أكبر', 'شرح التأمين وطريقة العمل وما الذي يشمله العرض.'],
        ['بيع الخدمة الصحيحة', 'فصل privatflytt وföretagsflytt وbärhjälp والتغليف والتركيب.'],
      ],
      includedTitle: 'أهم ما يحتاجه موقع شركة النقل',
      included: [
        'Privatflytt وföretagsflytt وbärhjälp والتغليف والتركيب والخدمات الحقيقية',
        'مناطق العمل والمسافة وطريقة حساب التنقل',
        'نموذج بالعناوين والتاريخ والطوابق والمصعد والحجم',
        'التأمين ورقم المنظمة وطرق التواصل الواضحة',
        'طريقة سعر بلا عروض مضللة أو شروط مخفية',
        'توافق الهاتف وSEO أساسي وربط النطاق والنشر',
      ],
      detailTitle: 'دع النموذج ينفذ جزءًا من العمل الأولي',
      details: [
        ['الأسئلة الصحيحة توفر الوقت', 'عندما يرسل العميل العناوين والطوابق والمصعد والصور عند الحاجة تستطيع الشركة تحديد الخطوة التالية أسرع.'],
        ['طريقة سعر واضحة', 'يمكن شرح سعر الساعة والحد الأدنى ورسوم السيارة أو المسافة وما يحتاج إلى تقييم منفصل.'],
        ['الثقة قبل التواصل', 'التأمين ورقم المنظمة وطريقة العمل الواضحة أهم من الوعود الإعلانية الكبيرة.'],
      ],
      processTitle: 'كيف نبني صفحة نقل قابلة للاستخدام',
      process: [
        ['01', 'نحدد الخدمات', 'أنواع النقل والحمل والخدمات الإضافية التي ستظهر.'],
        ['02', 'نرتب أسئلة العرض', 'نجمع فقط المعلومات التي تحتاجها الشركة للتقييم.'],
        ['03', 'نبني ونختبر', 'النموذج والهاتف والروابط وواتساب والشاشات الصغيرة.'],
        ['04', 'تراجع وتنشر', 'تؤكد الشركة الأسعار والشروط والتأمين قبل الإطلاق.'],
      ],
      faqTitle: 'أسئلة شائعة عن موقع شركة النقل',
      faqs: [
        ['هل يجب تأكيد الحجز مباشرة؟', 'ليس دائمًا. طلب عرض السعر غالبًا أكثر أمانًا لأن الحجم والعناوين والوصول تغير السعر.'],
        ['هل يمكن للعميل رفع صور؟', 'نعم، لكن الرفع والتخزين وظيفة إضافية تُحدد منفصلة عن نموذج التواصل البسيط.'],
        ['هل يمكن إنشاء صفحات لعدة مدن؟', 'نعم عندما تعمل الشركة فعلًا في تلك المدن وتملك محتوى مفيدًا مختلفًا، وليس عبر نسخ نفس الصفحة.'],
        ['كم يكلف الموقع البسيط؟', 'السعر الإرشادي نحو 4,900 كرون، ويحدد السعر النهائي والضريبة إن وجدت بعد تحديد الوظائف.'],
      ],
      ctaTitle: 'اشرح خدمات النقل وطريقة حساب السعر',
      ctaText: 'يمكنك إرسال رابط موجود أو صفحة Facebook أو قائمة بسيطة، ثم تحصل على اقتراح مكتوب قبل بدء العمل.',
    },
  },

  crafts: {
    id: 'crafts',
    svPath: '/hemsida-hantverkare',
    arPath: '/ar/hemsida-hantverkare',
    labelSv: 'Hantverkare & bygg',
    labelAr: 'الحرفيون والبناء',
    shortSv: 'Projektbilder, tjänster, områden, ROT och offertförfrågningar.',
    shortAr: 'صور المشاريع والخدمات والمناطق وROT وطلبات عروض السعر.',
    sv: {
      metaTitle: 'Hemsida för hantverkare och byggföretag | StartaWebb',
      metaDescription: 'Hemsida för snickare, målare, bygg- och serviceföretag med projektbilder, tjänster, områden, ROT och offertförfrågan. Riktpris cirka 4 900 kr.',
      keywords: 'hemsida hantverkare, hemsida byggföretag, webbdesign snickare, hemsida målare, offertformulär hantverkare',
      eyebrow: 'Hemsida för hantverkare och byggföretag',
      title: 'Visa vad ni gör, var ni arbetar och hur kunden ber om offert.',
      intro: 'En hantverkarsida ska göra det lätt att bedöma om företaget passar uppdraget. Tjänster, arbetsområden, projektbilder och nästa steg ska vara tydliga redan före första samtalet.',
      fitTitle: 'Sidan passar företag som vill',
      fit: [
        ['Få rätt typ av jobb', 'Beskriv vilka arbeten ni tar och vilka uppdrag som inte passar.'],
        ['Visa verkliga projekt', 'Använd egna bilder med kort information om uppdraget och resultatet.'],
        ['Förenkla offertsteget', 'Låt kunden beskriva plats, omfattning, önskad tid och bifoga länk eller bilder senare.'],
      ],
      includedTitle: 'Det viktigaste på en hantverkares hemsida',
      included: [
        'Tydliga sidor eller avsnitt för snickeri, målning, renovering, montering eller andra specialiteter',
        'Projektbilder och referenser som företaget har rätt att publicera',
        'Arbetsområden, typ av kunder och storlek på uppdrag',
        'ROT-information där den faktiskt är relevant',
        'Offertformulär med beskrivning, plats och önskad tid',
        'Mobilanpassning, grundläggande SEO, domän och publicering',
      ],
      detailTitle: 'Förtroende byggs med konkreta uppgifter',
      details: [
        ['Specialitet före allt', 'En målare, snickare och totalentreprenör behöver olika innehåll. Sidan ska inte försöka sälja arbeten företaget inte utför.'],
        ['Projekt som bevis', 'Före- och efterbilder med kort förklaring hjälper mer än generella bilder från en bildbank.'],
        ['Offert i rätt steg', 'Större arbeten kräver ofta bilder, mått eller platsbesök. Formuläret ska förbereda nästa steg, inte lova ett slutpris för tidigt.'],
      ],
      processTitle: 'Så tas hantverkarens sida fram',
      process: [
        ['01', 'Välj fokus', 'Prioritera de tjänster och uppdrag som företaget faktiskt vill få mer av.'],
        ['02', 'Samla projekt', 'Välj bilder, orter, kontaktuppgifter och viktiga förtroendesignaler.'],
        ['03', 'Bygg offertflödet', 'Gör det enkelt att beskriva uppdraget från mobil.'],
        ['04', 'Granska och publicera', 'Företaget godkänner tjänster, ROT-text och bilder före lansering.'],
      ],
      faqTitle: 'Vanliga frågor om hemsida för hantverkare',
      faqs: [
        ['Behöver vi många projektreferenser?', 'Nej. Några relevanta, äkta projekt med tydliga bilder är bättre än många generella exempel.'],
        ['Kan vi skriva att alla jobb ger ROT?', 'Nej. ROT beror på arbete, bostad och kundens förutsättningar. Texten ska vara korrekt och försiktig.'],
        ['Kan vi börja med en enkel sida?', 'Ja. Tjänster, områden, projektbilder och offertkontakt räcker ofta som första version.'],
        ['Vad kostar en enkel hantverkarsida?', 'Riktpriset är cirka 4 900 kr. Större galleri, uppladdning, flera avancerade formulär eller andra funktioner bedöms separat.'],
      ],
      ctaTitle: 'Skicka tjänsterna och några projektbilder',
      ctaText: 'Beskriv vilka jobb företaget vill få mer av. Du får ett tydligt förslag innan något arbete startar.',
    },
    ar: {
      metaTitle: 'موقع للحرفي أو شركة البناء في السويد | StartaWebb',
      metaDescription: 'موقع سويدي للنجار والدهان وشركة البناء يعرض المشاريع والخدمات والمناطق وROT ونموذج طلب عرض السعر، مع تواصل بالعربية.',
      keywords: 'موقع شركة بناء السويد, hemsida hantverkare, موقع نجار السويد, تصميم موقع حرفي, مصمم مواقع عربي السويد',
      eyebrow: 'موقع للحرفيين وشركات البناء',
      title: 'اعرض ما تنفذه الشركة وأين تعمل وكيف يطلب العميل عرض سعر.',
      intro: 'يجب أن تساعد الصفحة العميل على معرفة هل الشركة مناسبة للمهمة قبل الاتصال، عبر الخدمات ومناطق العمل وصور المشاريع والخطوة التالية.',
      fitTitle: 'الموقع مناسب للشركات التي تريد',
      fit: [
        ['وظائف مناسبة أكثر', 'شرح الأعمال التي تقبلها الشركة وما لا يدخل في تخصصها.'],
        ['عرض مشاريع حقيقية', 'صور تملك الشركة حق نشرها مع وصف قصير للعمل والنتيجة.'],
        ['طلب سعر أسهل', 'يجمع العميل الموقع والحجم والوقت المطلوب ووصف المهمة.'],
      ],
      includedTitle: 'أهم ما يحتاجه موقع الحرفي',
      included: [
        'أقسام للنجارة والدهان والترميم والتركيب أو التخصص الحقيقي',
        'صور مشاريع ومراجع تملك الشركة حق نشرها',
        'مناطق العمل ونوع العملاء وحجم المهمات',
        'معلومات ROT فقط عندما تكون مناسبة',
        'نموذج طلب عرض السعر مع المكان والوصف والوقت المطلوب',
        'توافق الهاتف وSEO أساسي وربط النطاق والنشر',
      ],
      detailTitle: 'الثقة تأتي من المعلومات الملموسة',
      details: [
        ['التخصص أولًا', 'الدهان والنجار والمقاول العام يحتاج كل منهم إلى محتوى مختلف، ولا يجب بيع خدمات لا تنفذها الشركة.'],
        ['المشاريع كدليل', 'صور قبل وبعد مع شرح قصير أقوى من صور عامة مأخوذة من مواقع الصور.'],
        ['عرض السعر في الخطوة المناسبة', 'المشاريع الكبيرة تحتاج صورًا أو قياسات أو زيارة، لذلك يجهز النموذج الخطوة التالية ولا يعد بسعر نهائي مبكرًا.'],
      ],
      processTitle: 'كيف يتم تجهيز موقع الحرفي',
      process: [
        ['01', 'نختار التركيز', 'الخدمات والمهمات التي تريد الشركة الحصول على المزيد منها.'],
        ['02', 'نجمع المشاريع', 'الصور والمدن وطرق التواصل وعناصر الثقة.'],
        ['03', 'نبني مسار العرض', 'طريقة سهلة لوصف المهمة من الهاتف.'],
        ['04', 'تراجع وتنشر', 'توافق الشركة على الخدمات ونص ROT والصور قبل الإطلاق.'],
      ],
      faqTitle: 'أسئلة شائعة عن موقع الحرفي',
      faqs: [
        ['هل نحتاج إلى مشاريع كثيرة؟', 'لا. عدد قليل من المشاريع الحقيقية والمرتبطة بالخدمات أفضل من أمثلة عامة كثيرة.'],
        ['هل يمكن القول إن كل الأعمال تحصل على ROT؟', 'لا. يعتمد ROT على نوع العمل والسكن ووضع العميل، ولذلك يجب أن تكون الصياغة دقيقة.'],
        ['هل يمكن البدء بصفحة بسيطة؟', 'نعم. الخدمات والمناطق وصور المشاريع وطلب العرض تكفي غالبًا للنسخة الأولى.'],
        ['كم يكلف الموقع البسيط؟', 'السعر الإرشادي نحو 4,900 كرون. المعارض الكبيرة والرفع والنماذج المتقدمة تُحسب منفصلة.'],
      ],
      ctaTitle: 'أرسل الخدمات وبعض صور المشاريع',
      ctaText: 'اشرح الأعمال التي تريد الشركة الحصول على المزيد منها، ثم تحصل على اقتراح واضح قبل بدء التنفيذ.',
    },
  },

  salon: {
    id: 'salon',
    svPath: '/hemsida-frisor-salong',
    arPath: '/ar/hemsida-frisor-salong',
    labelSv: 'Frisör & salong',
    labelAr: 'صالون وحلاقة',
    shortSv: 'Behandlingar, priser, bilder, öppettider och väg till bokning.',
    shortAr: 'الخدمات والأسعار والصور وساعات العمل والطريق إلى الحجز.',
    sv: {
      metaTitle: 'Hemsida för frisör och salong med priser och bokning | StartaWebb',
      metaDescription: 'Hemsida för frisör, barberare och skönhetssalong med behandlingar, priser, bilder, öppettider, karta och länk till bokning. Riktpris cirka 4 900 kr.',
      keywords: 'hemsida frisör, hemsida salong, webbdesign barberare, frisör bokning hemsida, prislista salong',
      eyebrow: 'Hemsida för frisör, barberare och salong',
      title: 'Samla behandlingar, priser, bilder och bokning utanför sociala medier.',
      intro: 'Instagram visar bilder, men kunden behöver också hitta prislista, öppettider, adress, regler och rätt bokningslänk utan att leta bland gamla inlägg.',
      fitTitle: 'Sidan passar när salongen vill',
      fit: [
        ['Göra bokning enklare', 'Länka rätt behandling till Bokadirekt, TimeCenter eller ett annat befintligt system.'],
        ['Visa prislistan tydligt', 'Dela upp behandlingar, längd, tid och pris utan en svårläst bild.'],
        ['Bygga lokal närvaro', 'Samla adress, karta, öppettider, parkering och kontakt på en egen sida.'],
      ],
      includedTitle: 'Det viktigaste på salongens hemsida',
      included: [
        'Behandlingar, prislista, ungefärlig tid och vad som ingår',
        'Bilder som salongen har rätt att publicera',
        'Bokningsknappar till ett befintligt system eller enkel förfrågan',
        'Adress, karta, öppettider, telefon och sociala medier',
        'Regler för avbokning, sen ankomst och konsultation när de finns',
        'Mobilanpassning, grundläggande SEO, domän och publicering',
      ],
      detailTitle: 'Gör vägen från inspiration till bokning kort',
      details: [
        ['Tjänster som går att förstå', 'Klippning, färg, skägg, fransar eller hudbehandling ska beskrivas med rätt namn, tid och prisnivå.'],
        ['Bokning utan dubbelarbete', 'När salongen redan använder ett bokningssystem länkar hemsidan dit i stället för att skapa en parallell kalender.'],
        ['Mobilen först', 'De flesta besökare vill snabbt se pris, lediga tider, adress och boka från telefonen.'],
      ],
      processTitle: 'Så byggs salongens webbplats',
      process: [
        ['01', 'Ordna behandlingarna', 'Samla namn, pris, tid, personal och bokningslänkar.'],
        ['02', 'Välj bilder', 'Använd salongens egna lokaler och arbeten när det finns tillstånd.'],
        ['03', 'Bygg mobilflödet', 'Prislista, karta och bokningsknappar testas på telefon.'],
        ['04', 'Godkänn och publicera', 'Salongen granskar priser, regler och kontaktuppgifter före lansering.'],
      ],
      faqTitle: 'Vanliga frågor om hemsida för frisör och salong',
      faqs: [
        ['Behöver vi bygga ett nytt bokningssystem?', 'Nej. Om salongen använder Bokadirekt eller en annan tjänst är det ofta bäst att länka rätt behandling dit.'],
        ['Kan prislistan ändras senare?', 'Ja. Hur enkelt det blir beror på vald teknik och om löpande uppdatering ingår i överenskommelsen.'],
        ['Kan vi använda bilder från Instagram?', 'Bara bilder som salongen äger eller har tillstånd att publicera, särskilt när kunder syns.'],
        ['Vad kostar en enkel salongssida?', 'Riktpriset är cirka 4 900 kr. Egen avancerad bokning, betalning eller medlemsfunktioner bedöms separat.'],
      ],
      ctaTitle: 'Skicka prislistan och bokningslänken',
      ctaText: 'Det räcker att börja med behandlingar, adress, öppettider och några bilder. Du får ett tydligt förslag före start.',
    },
    ar: {
      metaTitle: 'موقع لصالون أو حلاق في السويد مع الأسعار والحجز | StartaWebb',
      metaDescription: 'موقع سويدي للحلاق والصالون يعرض الخدمات والأسعار والصور وساعات العمل والخريطة ورابط الحجز، مع شرح ودعم بالعربية.',
      keywords: 'موقع صالون السويد, hemsida frisör, موقع حلاق السويد, تصميم موقع salong, مصمم مواقع عربي السويد',
      eyebrow: 'موقع للحلاق والصالون في السويد',
      title: 'اجمع الخدمات والأسعار والصور والحجز خارج منشورات التواصل الاجتماعي.',
      intro: 'يعرض Instagram الصور، لكن العميل يحتاج أيضًا إلى قائمة الأسعار وساعات العمل والعنوان والقواعد ورابط الحجز الصحيح دون البحث بين المنشورات.',
      fitTitle: 'الموقع مناسب عندما يريد الصالون',
      fit: [
        ['حجزًا أسهل', 'ربط كل خدمة بـBokadirekt أو TimeCenter أو النظام الموجود.'],
        ['قائمة سعر واضحة', 'تقسيم الخدمات والمدة والسعر بدل نشرها كصورة صعبة القراءة.'],
        ['حضورًا محليًا', 'العنوان والخريطة وساعات العمل والمواقف والتواصل في صفحة واحدة.'],
      ],
      includedTitle: 'أهم ما يحتاجه موقع الصالون',
      included: [
        'الخدمات والأسعار والمدة وما الذي تشمله الخدمة',
        'صور يملك الصالون حق نشرها',
        'أزرار حجز إلى النظام الموجود أو نموذج طلب بسيط',
        'العنوان والخريطة وساعات العمل والهاتف والتواصل الاجتماعي',
        'قواعد الإلغاء والتأخر والاستشارة عندما تكون موجودة',
        'توافق الهاتف وSEO أساسي وربط النطاق والنشر',
      ],
      detailTitle: 'قصّر الطريق من مشاهدة الصور إلى الحجز',
      details: [
        ['خدمات مفهومة', 'قص الشعر والصبغة واللحية والرموش أو البشرة تحتاج أسماء ووقتًا وسعرًا واضحًا.'],
        ['حجز بلا نظام مكرر', 'إذا كان الصالون يستعمل نظام حجز، يربط الموقع به بدل إنشاء تقويم ثانٍ.'],
        ['الهاتف أولًا', 'العميل يريد رؤية السعر والوقت والعنوان والحجز بسرعة من الهاتف.'],
      ],
      processTitle: 'كيف يتم بناء موقع الصالون',
      process: [
        ['01', 'نرتب الخدمات', 'الأسماء والأسعار والمدة والموظفون وروابط الحجز.'],
        ['02', 'نختار الصور', 'المكان والأعمال الحقيقية مع وجود حق النشر.'],
        ['03', 'نبني مسار الهاتف', 'قائمة الأسعار والخريطة وأزرار الحجز.'],
        ['04', 'تراجع وتنشر', 'يؤكد الصالون الأسعار والقواعد وبيانات التواصل.'],
      ],
      faqTitle: 'أسئلة شائعة عن موقع الصالون',
      faqs: [
        ['هل نحتاج إلى نظام حجز جديد؟', 'لا. عندما يستعمل الصالون Bokadirekt أو خدمة أخرى يكون الربط بها غالبًا أفضل.'],
        ['هل يمكن تغيير الأسعار لاحقًا؟', 'نعم، وسهولة التعديل تعتمد على التقنية وما تم الاتفاق عليه للصيانة.'],
        ['هل يمكن استعمال صور Instagram؟', 'فقط الصور التي يملك الصالون حق نشرها، خصوصًا عندما يظهر العملاء فيها.'],
        ['كم يكلف الموقع البسيط؟', 'السعر الإرشادي نحو 4,900 كرون. الحجز المتقدم والدفع والعضويات تُحسب منفصلة.'],
      ],
      ctaTitle: 'أرسل قائمة الأسعار ورابط الحجز',
      ctaText: 'يكفي البدء بالخدمات والعنوان وساعات العمل وبعض الصور، ثم تحصل على اقتراح واضح قبل التنفيذ.',
    },
  },

  restaurant: {
    id: 'restaurant',
    svPath: '/hemsida-restaurang',
    arPath: '/ar/hemsida-restaurang',
    labelSv: 'Restaurang & café',
    labelAr: 'مطعم ومقهى',
    shortSv: 'Meny, öppettider, karta, beställningslänkar och bordsbokning.',
    shortAr: 'القائمة وساعات العمل والخريطة وروابط الطلب وحجز الطاولة.',
    sv: {
      metaTitle: 'Hemsida för restaurang och café med meny och bokning | StartaWebb',
      metaDescription: 'Hemsida för restaurang, pizzeria och café med mobil meny, öppettider, karta, allergiinformation, beställningslänkar och bordsbokning.',
      keywords: 'hemsida restaurang, hemsida pizzeria, digital meny restaurang, webbdesign café, bordsbokning hemsida',
      eyebrow: 'Hemsida för restaurang, pizzeria och café',
      title: 'Gör meny, öppettider, adress och beställning lätta att hitta från mobilen.',
      intro: 'Kunden söker ofta precis före ett besök eller en beställning. Meny, pris, öppettider, adress och rätt beställningslänk måste därför vara tydliga utan att kräva en PDF eller ett socialt konto.',
      fitTitle: 'Sidan passar verksamheter som vill',
      fit: [
        ['Visa en mobil meny', 'Rätter och priser går att läsa utan att zooma i en bild eller gammal PDF.'],
        ['Samla rätt länkar', 'Foodora, Wolt, egen beställning, telefon och bordsbokning på rätt plats.'],
        ['Hjälpa gästen hitta', 'Öppettider, karta, parkering, tillgänglighet och kontakt på en tydlig sida.'],
      ],
      includedTitle: 'Det viktigaste på restaurangens hemsida',
      included: [
        'Meny med kategorier, priser och information som verksamheten ansvarar för',
        'Öppettider, adress, karta, telefon och sociala medier',
        'Länkar till beställning, leverans eller bordsbokning som redan används',
        'Information om lunch, catering, takeaway eller andra verkliga erbjudanden',
        'Bilder som restaurangen äger eller har tillstånd att publicera',
        'Mobilanpassning, grundläggande SEO, domän och publicering',
      ],
      detailTitle: 'Bygg sidan för beslutet som tas just nu',
      details: [
        ['Menyn ska gå att läsa', 'Textbaserad meny fungerar bättre på mobil och kan uppdateras utan att ersätta en bild överallt.'],
        ['En primär handling', 'Välj om sidan främst ska leda till bord, beställning, cateringförfrågan eller telefonsamtal.'],
        ['Aktuell information', 'Fel öppettider och gamla priser skadar förtroendet. Restaurangen behöver en tydlig rutin för uppdateringar.'],
      ],
      processTitle: 'Så byggs restaurangens sida',
      process: [
        ['01', 'Samla meny och länkar', 'Rätter, priser, öppettider, adress och befintliga beställningssystem.'],
        ['02', 'Välj huvudmål', 'Bordsbokning, takeaway, leverans, catering eller information.'],
        ['03', 'Bygg mobilversionen', 'Meny, karta och knappar testas där gästerna oftast använder dem.'],
        ['04', 'Granska och publicera', 'Restaurangen bekräftar priser, öppettider och allergiinformation före lansering.'],
      ],
      faqTitle: 'Vanliga frågor om restauranghemsidor',
      faqs: [
        ['Kan vi använda en PDF-meny?', 'Det går, men en textbaserad meny är ofta lättare att läsa på mobil och bättre för sökmotorer.'],
        ['Bygger ni egen matbeställning?', 'En avancerad beställnings- och betalningslösning är ett separat projekt. Den enkla sidan kan länka till systemet restaurangen redan använder.'],
        ['Kan sidan finnas på flera språk?', 'Ja, men varje språk behöver riktiga texter och underhåll. Omfattning och pris bestäms före arbetet.'],
        ['Vad kostar en enkel restaurangsida?', 'Riktpriset är cirka 4 900 kr. Stor meny, många språk, egen bokning eller beställning bedöms separat.'],
      ],
      ctaTitle: 'Skicka menyn, öppettiderna och beställningslänkarna',
      ctaText: 'Du får ett förslag på struktur och omfattning innan arbetet börjar.',
    },
    ar: {
      metaTitle: 'موقع لمطعم أو مقهى في السويد مع القائمة والحجز | StartaWebb',
      metaDescription: 'موقع سويدي للمطعم والبيتزا والمقهى يعرض القائمة والأسعار وساعات العمل والخريطة وروابط الطلب وحجز الطاولة، مع دعم بالعربية.',
      keywords: 'موقع مطعم السويد, hemsida restaurang, موقع pizzeria, قائمة طعام رقمية, مصمم مواقع عربي السويد',
      eyebrow: 'موقع للمطعم والمقهى في السويد',
      title: 'اجعل القائمة وساعات العمل والعنوان والطلب سهلة من الهاتف.',
      intro: 'غالبًا يبحث العميل قبل الزيارة أو الطلب مباشرة، لذلك يجب أن يجد القائمة والسعر والساعات والعنوان والرابط الصحيح من دون PDF صعب أو حساب تواصل اجتماعي.',
      fitTitle: 'الموقع مناسب للمطاعم التي تريد',
      fit: [
        ['قائمة تعمل على الهاتف', 'قراءة الأطباق والأسعار دون تكبير صورة أو PDF قديم.'],
        ['جمع الروابط الصحيحة', 'Foodora وWolt والطلب والهاتف وحجز الطاولة.'],
        ['مساعدة الضيف على الوصول', 'الساعات والخريطة والمواقف وإمكانية الوصول والتواصل.'],
      ],
      includedTitle: 'أهم ما يحتاجه موقع المطعم',
      included: [
        'قائمة بفئات وأسعار ومعلومات تتحمل المنشأة مسؤولية صحتها',
        'ساعات العمل والعنوان والخريطة والهاتف والتواصل الاجتماعي',
        'روابط الطلب والتوصيل أو حجز الطاولة الموجودة',
        'الغداء وcatering وtakeaway والعروض الحقيقية',
        'صور يملك المطعم حق نشرها',
        'توافق الهاتف وSEO أساسي وربط النطاق والنشر',
      ],
      detailTitle: 'ابنِ الصفحة للقرار الذي يتخذه العميل الآن',
      details: [
        ['قائمة قابلة للقراءة', 'القائمة النصية أوضح على الهاتف ويمكن تحديثها دون تغيير صورة في كل مكان.'],
        ['إجراء رئيسي واحد', 'حدد هل الهدف الأساسي الطاولة أو الطلب أو catering أو الاتصال.'],
        ['معلومات حديثة', 'الساعات والأسعار القديمة تضر الثقة، لذلك يجب وجود طريقة واضحة للتحديث.'],
      ],
      processTitle: 'كيف يتم بناء موقع المطعم',
      process: [
        ['01', 'نجمع القائمة والروابط', 'الأطباق والأسعار والساعات والعنوان وأنظمة الطلب.'],
        ['02', 'نحدد الهدف الرئيسي', 'حجز الطاولة أو takeaway أو التوصيل أو catering.'],
        ['03', 'نبني للهاتف', 'القائمة والخريطة والأزرار على الشاشة الصغيرة.'],
        ['04', 'تراجع وتنشر', 'يؤكد المطعم الأسعار والساعات ومعلومات الحساسية.'],
      ],
      faqTitle: 'أسئلة شائعة عن موقع المطعم',
      faqs: [
        ['هل يمكن استعمال قائمة PDF؟', 'يمكن ذلك، لكن القائمة النصية غالبًا أسهل على الهاتف وأفضل لمحركات البحث.'],
        ['هل تبنون نظام طلب ودفع؟', 'النظام المتقدم مشروع منفصل. الموقع البسيط يستطيع الربط بالنظام الموجود.'],
        ['هل يمكن إضافة عدة لغات؟', 'نعم، لكن كل لغة تحتاج نصوصًا صحيحة وصيانة، ويتم تحديد العمل والسعر قبل البدء.'],
        ['كم يكلف الموقع البسيط؟', 'السعر الإرشادي نحو 4,900 كرون. القائمة الكبيرة واللغات والحجز أو الطلب الخاص تُحسب منفصلة.'],
      ],
      ctaTitle: 'أرسل القائمة وساعات العمل وروابط الطلب',
      ctaText: 'تحصل على اقتراح للهيكل والعمل قبل أن يبدأ التنفيذ.',
    },
  },
};

export const INDUSTRY_ORDER = ['cleaning', 'moving', 'crafts', 'salon', 'restaurant'];

export function getIndustryPage(id) {
  return INDUSTRY_SEO_PAGES[id] || null;
}

export function getIndustryPages() {
  return INDUSTRY_ORDER.map((id) => INDUSTRY_SEO_PAGES[id]);
}
